import { useEffect, useState } from 'react';

import Spinner from '../../../../reusable/spinner/spinner.component';
import Client from '../../../../../tools/client';

import {
  FieldGroup,
  FieldSection,
  Label,
  Input,
  ButtonRow,
  Button,
  TextSmall
} from '../../configuration-sections.styles';

const client = new Client();

const OGMetadataConfigurationDisplay = () => {
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({});

  useEffect(() => {
    const fetch = async () => {
      const res = await client.setup();
      const site = res.configuration?.site || {};
      setForm({
        title: site.title || '',
        description: site.description || '',
        ogTitle: site.ogTitle || '',
        ogDescription: site.ogDescription || '',
      });
      setLoading(false);
    };
    fetch();
  }, []);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSave = async () => {
    for (const [key, value] of Object.entries(form)) {
      await client.updateConfigurationByKey(`site.${key}`, { value });
    }
    setEditing(false);
  };

  if (loading) return <Spinner />;

  return (
    <FieldSection>
      <FieldGroup>
        <Label htmlFor="title">Site Title</Label>
        <TextSmall>This is the title shown in the browser tab and search engine listings.</TextSmall>
        <Input
          name="title"
          value={form.title}
          onChange={handleChange}
          disabled={!editing}
        />
      </FieldGroup>

      <FieldGroup>
        <Label htmlFor="description">Site Description</Label>
        <TextSmall>This short description is used in meta tags for SEO and link previews.</TextSmall>
        <Input
          name="description"
          value={form.description}
          onChange={handleChange}
          disabled={!editing}
        />
      </FieldGroup>

      <FieldGroup>
        <Label htmlFor="ogTitle">OG Title</Label>
        <TextSmall>This title is used in Open Graph meta tags for social media shares.</TextSmall>
        <Input
          name="ogTitle"
          value={form.ogTitle}
          onChange={handleChange}
          disabled={!editing}
        />
      </FieldGroup>

      <FieldGroup>
        <Label htmlFor="ogDescription">OG Description</Label>
        <TextSmall>This description appears below the OG title when the page is shared.</TextSmall>
        <Input
          name="ogDescription"
          value={form.ogDescription}
          onChange={handleChange}
          disabled={!editing}
        />
      </FieldGroup>

      <ButtonRow>
        {editing ? (
          <>
            <Button onClick={() => setEditing(false)}>Cancel</Button>
            <Button primary onClick={handleSave}>Save</Button>
          </>
        ) : (
          <Button primary onClick={() => setEditing(true)}>Edit</Button>
        )}
      </ButtonRow>
    </FieldSection>
  );
};

export default OGMetadataConfigurationDisplay;